import * as ActionTypes from 'actions/partnerPlanRatingVisibility'

const initialState = {
  isFetching: false,
  isError: false,
  fetched: false,
  ratingVisibility: [],
  planYear: [],
}

const getPartnerPlanFy = (items) => {
  // eslint-disable-next-line array-callback-return
  const fy = items
    .map(item => item.year)
    .filter((value, index, self) => self.indexOf(value) === index)

  const planYearOptions = []
  fy.map(item =>
    planYearOptions.push({ value: `${item}`, label: `${item}` }))
  return planYearOptions
}

// Updates error message to notify about the failed fetches.
export default function partnerPlanRatingVisibility(state = initialState, action) {
  switch (action.type) {
    case ActionTypes.PARTNERPLANRATINGVISIBILITY_SAVE_REQUEST:
    case ActionTypes.PARTNERPLANRATINGVISIBILITY_GET:
      return {
        ...state,
        isFetching: true,
      }
    case ActionTypes.PARTNERPLANRATINGVISIBILITY_SAVE_COMPLETE:
    case ActionTypes.PARTNERPLANRATINGVISIBILITY_RECEIVED:
      return {
        ...state,
        isFetching: false,
        fetched: true,
        ratingVisibility: action.ratingVisibility,
        planYear: getPartnerPlanFy(action.ratingVisibility),
      }  
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/partnerPlanRatingVisibility.js